
import React from 'react';
import ReadingDay2024 from 'views/ReadingDay2024';

const RentalPage = () => {
  return <ReadingDay2024 />;
};

export default RentalPage;
